import { create } from 'zustand';
import { TrackingService } from '@/services/analytics/TrackingService';

type HomeStore = {
    isHomeMenuVisible: boolean;
    isHelpPopupOpen: boolean;
    isScreenSaverListOpen: boolean;
    setHomeMenuVisible: (visible: boolean) => void;
    setHelpPopupOpen: (open: boolean) => void;
    setScreenSaverListOpen: (open: boolean) => void;
    resetHomeMenu: () => void;
    closeHomePopups: () => void;
};

export const useHomeStore = create<HomeStore>()((set, get) => ({
    isHomeMenuVisible: false,
    isHelpPopupOpen: false,
    isScreenSaverListOpen: false,
    setHomeMenuVisible: (visible) => {
        const { isHomeMenuVisible } = get();
        if (isHomeMenuVisible === visible) return;

        if (visible) {
            set({ isHomeMenuVisible: true });
            TrackingService.onHomePopupOpen();
            return;
        }

        // Hide menu + close home popups so UI does not linger over screensaver
        set({ isHomeMenuVisible: false, isHelpPopupOpen: false, isScreenSaverListOpen: false });
        TrackingService.onHomeMenuHiddenByNavigation();
    },
    setHelpPopupOpen: (open) => {
        const { isHelpPopupOpen } = get();
        if (isHelpPopupOpen === open) return;
        set({ isHelpPopupOpen: open });
    },
    setScreenSaverListOpen: (open) => {
        const { isScreenSaverListOpen } = get();
        if (isScreenSaverListOpen === open) return;
        set({ isScreenSaverListOpen: open });
    },
    closeHomePopups: () => {
        set({ isHelpPopupOpen: false, isScreenSaverListOpen: false });
    },
    resetHomeMenu: () => {
        const { isHomeMenuVisible } = get();
        if (isHomeMenuVisible) {
            TrackingService.onHomeMenuHiddenByNavigation();
        }
        set({ isHomeMenuVisible: false, isHelpPopupOpen: false, isScreenSaverListOpen: false });
    },
}));
